import ButtonView from './ButtonView'
import ButtonText from './ButtonText'
import Bold from '../../../shared/components/Bold'
import MainFormCheckBox from './MainFormCheckBox'
import EmailVerifiedSuccessMessage from './EmailVerifiedSuccessMessage'

export default {
  ButtonView,
  ButtonText,
  Bold,
  MainFormCheckBox,
  EmailVerifiedSuccessMessage,
}
